import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface IDeliveryNoteState {
  approvedDelivery: Array<number>;
}

const initialState: IDeliveryNoteState = {
  approvedDelivery: [],
};

const approvedDeliverySlice = createSlice({
  name: "aprDelivery",
  initialState,
  reducers: {
    setApprovedDelivery: (state, action: PayloadAction<Array<number>>) => {
      state.approvedDelivery = action.payload;
    },
    clearApprovedDelivery: (state) => {
      state.approvedDelivery = [];
    },
  },
});

export const { setApprovedDelivery, /*clearApprovedDelivery*/ } =
  approvedDeliverySlice.actions;
export default approvedDeliverySlice.reducer;
